/* eslint-disable  */
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom'
import { ReactComponent as IconArrowRight } from 'images/arrow-right.svg';
import Page from 'modules/app/components/Page';
import Skeleton from 'components/shared/Skeleton';
import PageContainer from 'components/shared/PageContainer';
import { ReactComponent as IconSearch } from 'images/search.svg';
import { ReactComponent as IconClear } from 'images/icons/search/clear.svg';
import useGetIndexByQuery from 'sdk/hooks/search/useGetIndexByQuery';
import clsx from 'clsx';
import NoContent from 'components/shared/NoContent/NoContent';
import Input from 'components/shared/Input';
import Button from 'components/shared/Button';
import styles from './Hashtags.module.scss';

function HashtagsSkeleton() {
  const navigate = useNavigate()
  return (
    <PageContainer className={styles.container}>
      <div className={styles.headerRow}>
        <div className={styles.h} onClick={() => navigate(-1)}>
          <div className={styles.title}>
            <IconArrowRight />
            Hashtags
          </div>
        </div>
      </div>
      <div className={styles.hashtags}>
        {Array.from(Array(10).keys()).map((item: number) => (
          <Skeleton
            key={item}
            className={styles.hashtagsItem}
          />
        ))}
      </div>
    </PageContainer>
  )
}

function Hashtags() {
  const [search, setSearch] = useState('')
  const [openSearch, setOpenSearch] = useState<boolean>(false)
  const {
    mutate: getIndex,
    data, isLoading,
    isSuccess,
  } = useGetIndexByQuery()
  const [hashtags, setHashtags] = useState(data)
  const [loaded, setLoaded] = useState<boolean>(false);
  const navigate = useNavigate()

  const handleSearchChange = (e: React.FormEvent<HTMLInputElement>) => {
    setSearch((e.target as HTMLInputElement).value)
  }

  useEffect(() => {
    getIndex({ query: search, index: 'hashtags' })
  }, [search])

  useEffect(() => {
    if (isSuccess) {
      setLoaded(true)
      setHashtags(data.map((item) => {
        const copy = item
        copy.label = item?.label?.replace('#', '');
        return copy
      }))
    }
  }, [isSuccess])

  if (isLoading && !loaded) {
    return (<HashtagsSkeleton />)
  }

  return (
    <PageContainer className={styles.container}>
      <div className={styles.headerRow}>
        <div
          className={clsx(
            styles.h,
            openSearch && styles.h_search,
          )}
          onClick={() => navigate(-1)}
        >
          <h1 className={styles.title}>
            <IconArrowRight />
            Hashtags
          </h1>
        </div>
        <Button
          className={styles.searchBtn}
          onClick={() => setOpenSearch(true)}
          iconBtn
        >
          <IconSearch />
        </Button>
        { openSearch && (
          <Input
            icon={<IconSearch className={styles.prefix} />}
            suffix={<IconClear className={styles.suffix} onClick={() => setOpenSearch(false)} />}
            className={styles.searchInput}
            value={search}
            onChange={handleSearchChange}
            placeholder="Search on Beautify"
          />
        )}
      </div>
      {hashtags?.length ? (
        <div className={clsx(
          styles.hashtags,
        )}
        >
          {hashtags?.map((hashtag) => (
            <div className={styles.hashtagsItem} key={hashtag?.objectID}>
              <div className={styles.nameBlock}>
                <span className={styles.nameBlockIcon}>#</span>
                <span className={styles.name}>{hashtag?.label}</span>
              </div>
              <div className={styles.countBlock}>
                <span className={styles.count}>{hashtag?.posts_count}</span>
                {' '}
                <span className={styles.countCaption}>Videos</span>
              </div>
              <div className={styles.arrowButton}>
                <IconArrowRight />
              </div>
              <Link className={styles.link} to={`/hashtags/${hashtag?.objectID}`} />
            </div>
          ))}
        </div>
      ) : null}
      {!hashtags?.length && (
        <div className={isLoading ? styles.hashtags_loading : ''}>
          <NoContent
            message="No data satisfying the filters"
          />
        </div>
      )}
    </PageContainer>
  )
}

function HashtagsPage() {
  return (
    <Page activeLink="/">
      <Hashtags />
    </Page>
  )
}

export default HashtagsPage
